import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { FullTable } from '../../Component/Table/FullTable';
import { URLS } from '../../Services/Constant';
import { get } from '../../Services/ApiHandler';

const PurchaseReport = () => {

    const [pagination, setPagination] = useState("");
    const [page, setPage] = useState(1);

    const location = useLocation();
    const listData = location.state?.listData;
    const reportName = location.state?.reportName;
    const slotId = location.state?.slotId;
    // // console.log("listData", listData);

    const [listingData, setListingData] = useState(listData || []);

    const fetchPurchaseReport = async () => {
        const res = await get(`${URLS.REPORTLIST}/${reportName}?game_slot_id[]=${slotId}`);
        // // console.log("res report", res);
        setListingData(res || []);
    }
useEffect(() => {
    if (!slotId) return; // don't fetch with an invalid/missing slot id
    fetchPurchaseReport();
}, [slotId, reportName]);

    
    const columns = React.useMemo(
        () => [
            {
                Header: "Date",
                accessor: "date",
                Cell: ({ value, row }) => {
                    return <p className="text-nowrap">{value}</p>;
                },
            },
            {
                Header: " Time",
                accessor: "time",
                Cell: ({ value, row }) => {
                    return <p className="text-nowrap">{value}</p>;
                },
            },
            {
                Header: " Lot",
                accessor: "lot",
                Cell: ({ value, row }) => {
                    return <p className="text-nowrap">{value === "Kerala" ? "Kerala" : "Dear"}</p>;
                },
            },
            {
                Header: "Lot Details",
                accessor: "lot_details",
                Cell: ({ value }) => {
                    const text = value || "";

                    const lower = text.toLowerCase();
                    let index = -1;

                    if (lower.includes("dear")) {
                        index = lower.indexOf("dear");
                    } else if (lower.includes("kerala")) {
                        index = lower.indexOf("kerala");
                    }

                    let firstLine = text;
                    let secondLine = "";

                    if (index !== -1) {
                        firstLine = text.substring(0, index).trim();
                        secondLine = text.substring(index).trim();
                    }

                    return (
                        <div>
                            <p>{firstLine}</p>
                            {secondLine && <p>{secondLine}</p>}
                        </div>
                    );
                },
            },

            {
                Header: "Lot Number",
                accessor: "my_number",
                Cell: ({ value, row }) => {
                    return <p className="text-nowrap">{value}</p>;
                },
            },
            {
                Header: "Qty",
                accessor: "qty",
                Cell: ({ value, row }) => {
                    return <p className="text-nowrap">{value}</p>;
                },
            },
            {
                Header: "Price",
                accessor: "fees",
                Cell: ({ value, row }) => {
                    return <p className="text-nowrap">{value}</p>;
                },
            },
            {
                Header: "Result",
                accessor: "announce_status",
                Cell: ({ value, row }) => {
                    return <div className='d-flex ac-jc'>
                        <p className={`${value == "Pending" ? "err-btn" : "appr-btn"}`}>{value}</p>
                    </div>
                },
            },


        ],
        []
    );



    return (
        <div className='dashRightView p-0 pb-2'>
            {/* <div className=' p-3'>
                <DateRange />

            </div> */}
            <FullTable
                columns={columns}
                setPageno={setPage}
                pagecount={pagination}
                data={listingData?.data || []}
                // tableHeight={"75vh"}
                show={false}
            />

            <div className="screen-pagination">
                <div
                    className="d-flex ac-jb bg-primary1 white p-2 px-3"
                    style={{ marginBottom: 3 }}
                >
                    <p className="f3 fs-xs-14 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22">
                        Total Price
                    </p>
                    <p className="f3 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24">
                        ₹ {listingData?.total_amount}
                    </p>
                </div>
            </div>
        </div>
    )
}
export default PurchaseReport